import { Download, Heart, Tag, Share } from "lucide-react";
import React, { useContext, useMemo } from "react";
import { BOTTOM_VIEW } from "../services/constant";
import ParamsContext from "../context/ParamsContext";
import CircularProgress from "./CircularProgress";
import { useFeatureActions } from "../hooks/useFeatureActions";
import { useTheme } from "../context/ThemeContext";

const FeaturesCompo = ({ setBottomView }) => {
	const { tryonData, isTryonAvailable, productDetails,scanData,IsToShowCaraousal } = useContext(ParamsContext);
	const productTitle = useMemo(() => productDetails?.searchResults?.[0]?.title ?? "", [productDetails]);
	const { handleLike, handleShareLink, handleDowloadLink, likeLoading, isShareLoading, isDownloadLoading, isLiked } = useFeatureActions({ tryonId: isTryonAvailable, productTitle });
	const { theme } = useTheme();
	return (
		<div className={`absolute z-[5] left-3 flex flex-col ${tryonData ? "top-8" : "z-10 top-3"}`}>
			{tryonData && (
				<>
					<div className="flex flex-col space-y-3 mb-3">
						<button
							onClick={handleLike}
							disabled={likeLoading || IsToShowCaraousal}
							className={`p-2.5 transition-all duration-200 hover:scale-105 w-[36px] h-[36px] ${theme === "light" ? "text-gray-900" : "text-gray-100"}`}
						>
							{likeLoading ? <CircularProgress size={16} /> : <Heart className={`w-[16px] ${!isLiked && "fill-red-500 stroke-red-500"}`} />}
						</button>
						<button
							onClick={handleShareLink}
							disabled={isShareLoading || IsToShowCaraousal}
							className={`p-2.5 transition-all duration-200 hover:scale-105 w-[36px] h-[36px] ${theme === "light" ? "text-gray-900" : "text-gray-100"}`}
						>
							{isShareLoading ? <CircularProgress /> : <Share className="w-[16px]" />}
						</button>
						<button
							onClick={handleDowloadLink}
							disabled={isDownloadLoading || IsToShowCaraousal}
							className={`p-2.5 transition-all duration-200 hover:scale-105 w-[36px] h-[36px] ${theme === "light" ? "text-gray-900" : "text-gray-100"}`}
						>
							{isDownloadLoading ? <CircularProgress /> : <Download className="w-[16px]" />}
						</button>
					</div>
					{/* <hr className={`w-6 h-px mx-auto mb-3 ${theme === "light" ? "bg-gray-300" : "bg-gray-700"}`} /> */}
				</>
			)}

			{/* <div className="flex flex-col space-y-3 mb-3"> */}
				{/* <button className={`p-2.5 transition-all duration-200 hover:scale-105 w-[36px] h-[36px] ${theme === "light" ? "text-gray-900" : "text-gray-100"}`}>
					<ShoppingBag onClick={() => setBottomView(BOTTOM_VIEW.PRODUCT)} className="w-[16px]" />
				</button> */}
				{scanData && tryonData &&  <button className={`p-2.5 transition-all duration-200 hover:scale-105 w-[36px] h-[36px] ${theme === "light" ? "text-gray-900" : "text-gray-100"}`}>
					<Tag onClick={() => setBottomView(BOTTOM_VIEW.MEASUREMENT)} className="w-[16px]" />
				</button>}
			{/* </div>
			<hr className={`w-6 h-px mx-auto mb-3 ${theme === "light" ? "bg-gray-300" : "bg-gray-700"}`} /> */}
			{/* <div className="flex flex-col space-y-3 mb-3">
				<button onClick={toggleTheme} className={`p-2.5 transition-all duration-200 hover:scale-105 w-[36px] h-[36px] ${theme === "light" ? "text-gray-900" : "text-gray-100"}`}>
					{theme === "light" ? <Moon className="w-[16px]" /> : <SunMoon className="w-[16px]" />}
				</button>
			</div> */}
		</div>
	);
};

export default FeaturesCompo;
